export default class DoublyLinkedListNode {
  constructor(item, previous, next) {
    this.item = item;
    this.previous = previous;
    this.next = next;
  }

}
//# sourceMappingURL=doubly-linked-list-node.js.map